import { AdverseEventsScreen } from '../features/console';

export function AdverseEventsPage() {
  return <AdverseEventsScreen />;
}
